import { Product } from "@/types/product";

function convertTo2DArray<T>(arr: T[], cols: number): T[][] {
  if (cols <= 0 || !Number.isInteger(cols)) {
    throw new Error("列数必须是正整数");
  }

  const result: T[][] = [];
  for (let i = 0; i < arr.length; i += cols) {
    result.push(arr.slice(i, i + cols));
  }
  return result;
};

function generateDiy2DArray<T, K extends keyof T>(
  arr: T[],
  splitKey: K,
  splitLength: number
): (T & { seq: number })[][] {
  const result: (T & { seq: number })[][] = [];
  let currentGroup: (T & { seq: number })[] = [];
  let currentLength = 0;

  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    const splitValue = item[splitKey];
    const itemLength = Array.isArray(splitValue) ? (splitValue.length || 1) : 1;

    // 如果某个元素的 length 大于 splitLength，返回空数组
    if (itemLength > splitLength) {
      return [];
    }

    // 检查是否需要开始新组
    if (currentLength + itemLength > splitLength) {
      result.push(currentGroup);
      currentGroup = [];
      currentLength = 0;
    }

    currentGroup.push({ ...item, seq: i });
    currentLength += itemLength;
  }

  // 添加最后一组
  if (currentGroup.length > 0) {
    result.push(currentGroup);
  }

  return result;
}
interface SortItem {
  count: number;
  product: Product | null | undefined;
}

// 排序：1. count为0的在后面 2. code非纯数字的在后面 3. 纯数字code从小到大排序
const sortOrderItems = (a: SortItem, b: SortItem) => {
  // 1. count为0的在后面
  if (a.count === 0 && b.count !== 0) return 1;
  if (a.count !== 0 && b.count === 0) return -1;

  const codeA = a.product?.code || '';
  const codeB = b.product?.code || '';

  // 判断是否为纯数字
  const isNumericA = /^\d+$/.test(codeA);
  const isNumericB = /^\d+$/.test(codeB);

  // 2. code不是纯数字的在后面
  if (!isNumericA && isNumericB) return 1;
  if (isNumericA && !isNumericB) return -1;

  // 3. 纯数字的code从小到大排序
  if (isNumericA && isNumericB) {
    return parseInt(codeA, 10) - parseInt(codeB, 10);
  }

  return 0;
}

export default convertTo2DArray;
export { generateDiy2DArray, sortOrderItems };